import { translate } from '$i18n/i18n'
import { ValidationError } from 'yup'
import type { FormError } from '$types/formError.ts'

export function getFormErrors(error: unknown, pathPrefix: string): FormError[] {
	// only yup errors carry form paths; anything else is a real failure for the caller
	if (!ValidationError.isError(error)) throw error

	const result: FormError[] = []
	if (error.inner.length !== 0) {
		error.inner.forEach((err) =>
			result.push({ path: pathPrefix + err.path, message: translate('de', err.message) })
		)
		return result
	}
	result.push({ path: error.path ?? '', message: translate('de', error.message) })
	return result
}

export function isExactPathInErrorList(errors: FormError[], fieldPath: string): boolean {
	return errors.some((error) => error.path === fieldPath)
}

export function isPathInErrorList(errors: FormError[], fieldPath: string): boolean {
	fieldPath = fieldPath.split('.*').join('')
	return errors.some((error) => error.path.includes(fieldPath))
}

export function getExactPathErrorMessage(errors: FormError[], fieldPath: string): string {
	return errors.find((error) => error.path === fieldPath)?.message ?? ''
}

export function getPathErrorMessage(errors: FormError[], fieldPath: string): string {
	fieldPath = fieldPath.split('.*').join('')
	return errors.find((error) => error.path.includes(fieldPath))?.message ?? ''
}
